import React, { useState, useContext } from "react"
import { Link } from "gatsby"
import {ChildAPIContext, checkLoggedIn } from './../../utils/childapi'
import Logo from '../../images/phonesmart-licence.png'
import "./Navigation.scss"
import "./KidsNavigation.scss"
import { navigate } from "gatsby-link"


const KidsNavigation = () => {
	const {childAPI} = useContext(ChildAPIContext)
	const [childAPIState, childAPIdispatch] = childAPI;  
	const [hoverClass, setHover] = useState(null);
	
	const removeHover = (e) => {
		setHover('')
	}

	const addHover = (e) => {
		setHover('bg--hover')
	}
	const uuid = (typeof window !== "undefined") && localStorage.getItem("uid");
	const userConsent = (typeof window !== "undefined") && localStorage.getItem("userConsent");

	const Logout = async (e) =>  {
		childAPIdispatch({ action: "logout-child",  data: {} });
	} 

return(
	<nav id="mainNav" className={`navbar navbar-expand-md bg--split ${hoverClass}`}>
		<div className="container-fluid container-md  bg--inner p-0">
			<div className="nav-wrapper">
				<div className="logo"> 
					<Link to={`/kids/`}  data-analytics='{"event":"Navigation", "eventCategory":"Navigation", "eventAction":"Logo Click", "eventLabel":"Child Homepage"}'>
						<img src={Logo} alt="EEPhonesmart" />
					</Link>
				</div>
				{
					(!checkLoggedIn())?	
						<div className="account-section">				
							<ul className="navbar-nav">
								<li className="nav-item bg--outer nav-item-separate ">
									<Link to={`/`} className="nav-link link notransition" onMouseOver={addHover} onMouseLeave={removeHover}
										data-analytics='{"event":"Navigation", "eventCategory":"Navigation", "eventAction":"Header Link Click", "eventLabel":"For grown ups"}'>
											For grown ups
									</Link>
								</li>
							</ul>
						</div>
					: 
						<div className="account-section">				
							<ul className="navbar-nav">
								<li className="nav-item bg--outer nav-item-separate ">
									<Link to={`/kids/?u=${uuid}&c=${userConsent}`} onClick={(e)=> {Logout(e)}} className="log-out nav-link link notransition" onMouseOver={addHover} onMouseLeave={removeHover}
										data-analytics='{"event":"Navigation", "eventCategory":"Navigation", "eventAction":"Header Link Click", "eventLabel":"Log out"}'>
											Log out
									</Link>
								</li>
							</ul>
						</div>
				}	
			</div>
		</div>	
	</nav>
)
}

export default KidsNavigation
